import { useState, useCallback, useEffect } from 'react';

function debounce(fn, ms) {
    if (ms === void 0) { ms = 0; }
    var timer;
    return function () {
        if (timer !== null) {
            clearTimeout(timer);
        }
        timer = setTimeout(function () {
            timer = null;
            fn();
        }, ms);
    };
}
function useBreakpoint(_a) {
    var min = _a.min, max = _a.max, includeMin = _a.includeMin, includeMax = _a.includeMax, _b = _a.visibleOnInit, visibleOnInit = _b === void 0 ? true : _b;
    var _c = useState(visibleOnInit), visible = _c[0], setVisible = _c[1];
    var onResize = useCallback(debounce(function () {
        var width = window.innerWidth;
        var _max = max || Infinity;
        var _min = min || 0;
        var MaxOK = includeMax ? width <= _max : width < _max;
        var MinOK = includeMin ? width >= _min : width > _min;
        if (MaxOK && MinOK)
            setVisible(true);
        else
            setVisible(false);
    }, 50), [min, max]);
    useEffect(function () {
        onResize();
        var _onResize = onResize;
        window.addEventListener('resize', _onResize);
        return function () {
            window.removeEventListener('resize', _onResize);
        };
    }, [onResize]);
    return visible;
}

export { useBreakpoint };
//# sourceMappingURL=useBreakpoint.js.map
